export const azulAlameda = '#1356d3';

export default {
    panel: azulAlameda,
    alumnoEsApoderado: azulAlameda,
};



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/colores.ts